import { Controller } from "@hotwired/stimulus"
import { apiUrl, getByAxios } from "../helpers/axios.js"

export default class extends Controller {
  static targets = ['body', 'link', 'partlink', 'ajaxdata']

  connect() {
    setTimeout(() => {
      const form = $(this.bodyTarget).closest('form')
      form.data('serialized', form.serialize())
    }, 200)
    const axios = require('axios')
    this.partlinkTargets.forEach((el) => {
      this.get_formpartlink_additional_data(el, axios)
    })

    this.ajaxdataTargets.forEach((el) => {
      this.get_additional_data(el, axios)
    })
  }

  get_formpartlink_additional_data(el, axios) {
    let path = el.dataset.formPartPath
    if(path == "") { return }
    let aEl = el.getElementsByClassName('part-content')[0]
    if (!aEl.innerHTML.includes('<em>')) {
      getByAxios(axios, `${el.dataset.formPartPath}.json?form_part=true`)
      .then(function (response) {
        if (response.data.result) {
          aEl.innerHTML = `${aEl.innerHTML}<small>${response.data.result}</small><em></em>`
        }
      }) 
    }
  }

  get_additional_data(el, axios) {
    let path = el.dataset.ajaxDataLink
    if(path == "") { return }
    getByAxios(axios, `${el.dataset.ajaxDataLink}`)
    .then(function (response) {
      if (response.data) {
        el.innerHTML = response.data
      }
    })
  }

  date_on_paste(e) {
    try {
      let text = (e.clipboardData || window.clipboardData).getData('text')
      let date = new Date(text.trim().replace(/\s+/g, " "))

      let date_str = date.format("yyyy-mm-dd")
      let time_str = date.format("HH:MM")
      let date_el = $(e.currentTarget)

      if (date.toJSON().substring(10,24) != "T00:00:00.000Z") {
        date_el.val(date_str)
        $(`#${date_el.attr('id').replace('date','time')}`).val(time_str)
        e.preventDefault()
      }
    } catch (error) {

    }
  }

  copy_this(event) {
    event.preventDefault()
    this.copyToClipboard(event.currentTarget.getElementsByClassName('copy-this')[0].innerHTML )
    $(document).Toasts('create', {
      autohide: true,
      position: 'bottomLeft',
      delay: 3000,
      title: event.currentTarget.dataset.title,
      body: event.currentTarget.dataset.message,
      class: 'bg-success'
    })
  }

  copyToClipboard(str) {
    const el = document.createElement('textarea')
    el.value = str
    el.setAttribute('readonly', '')
    el.style.position = 'absolute'
    el.style.left = '-9999px'
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
  }

}
